import React from 'react';
import { FadeIn } from './FadeIn';
import { BookOpen, ListChecks, ShoppingCart, AlertCircle } from 'lucide-react';
export function WhatsInside() {
  const parts = ['Parte 1: Prepará el terreno', 'Parte 2: Las bases de una alimentación saludable', 'Parte 3: El Método de 30 Días', 'Parte 4: Recetas Airfryer Fit', 'Parte 5: Mantener los resultados'];
  return <section className="py-20 bg-white" data-id="element-259">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-260">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-261">
          <FadeIn direction="right" data-id="element-262">
            <div className="relative rounded-3xl overflow-hidden aspect-[4/3] shadow-xl" data-id="element-263">
              <img src="https://images.unsplash.com/photo-1546069901-ba9599a7e63c?auto=format&fit=crop&w=1000&q=80" alt="Bowl saludable" className="w-full h-full object-cover" data-id="element-264" />
              <div className="absolute inset-0 bg-brand-900/10 mix-blend-multiply" data-id="element-265" />
            </div>
          </FadeIn>

          <FadeIn direction="left" data-id="element-266">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-stone-900 mb-6" data-id="element-267">
              ¿Qué vas a encontrar adentro?
            </h2>
            <p className="text-lg text-stone-600 mb-8" data-id="element-268">
              El ebook está dividido en 5 partes prácticas para que vayas de la
              teoría a la acción sin perder tiempo.
            </p>

            <div className="space-y-4 mb-8" data-id="element-269">
              {parts.map((part, i) => <div key={i} className="flex items-center gap-3" data-id="element-270">
                  <div className="bg-brand-100 p-1.5 rounded-full text-brand-600" data-id="element-271">
                    <BookOpen className="w-4 h-4" data-id="element-272" />
                  </div>
                  <span className="font-medium text-stone-800" data-id="element-273">{part}</span>
                </div>)}
            </div>

            <div className="grid sm:grid-cols-3 gap-4 border-t border-stone-200 pt-8" data-id="element-274">
              <div className="text-center" data-id="element-275">
                <ListChecks className="w-8 h-8 text-emerald-500 mx-auto mb-2" data-id="element-276" />
                <p className="font-bold text-stone-900 text-sm" data-id="element-277">
                  Plan Diario Completo
                </p>
              </div>
              <div className="text-center" data-id="element-278">
                <ShoppingCart className="w-8 h-8 text-emerald-500 mx-auto mb-2" data-id="element-279" />
                <p className="font-bold text-stone-900 text-sm" data-id="element-280">
                  Listas de Compras
                </p>
              </div>
              <div className="text-center" data-id="element-281">
                <AlertCircle className="w-8 h-8 text-emerald-500 mx-auto mb-2" data-id="element-282" />
                <p className="font-bold text-stone-900 text-sm" data-id="element-283">
                  Menús de Emergencia
                </p>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}